module.exports = __webpack_public_path__ + "static/img/showroom3.b083c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom3.png
// module id = hFVb
// module chunks = 2